import { IReferenceItem, ReferenceRecord } from "../models/referenceData";
import { httpServices } from "./httpCommon";

export const ReferenceDataService = {
    async getReferenceData<T extends IReferenceItem>(keys: string): Promise<T[]> {
        return (await httpServices.get<ReferenceRecord<T>[]>(`/reference?keys=${keys}`)).data[0].value;
    }
};
